import { useEffect, useState } from "react";
import { navLinks } from "@/mocks/comicData";

export default function Navbar() {
  const [scrolled, setScrolled] = useState(false);
  const [open, setOpen] = useState(false);

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 20);
    onScroll();
    window.addEventListener("scroll", onScroll);
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  const go = (href: string) => {
    setOpen(false);
    const el = document.querySelector(href);
    if (el) el.scrollIntoView({ behavior: "smooth" });
  };

  return (
    <header
      className={`fixed inset-x-0 top-0 z-50 transition-all duration-300 ${
        scrolled
          ? "bg-background-50/90 backdrop-blur-md shadow-[0_1px_0_0] shadow-background-200/80"
          : "bg-transparent"
      }`}
    >
      <div className="section-x flex h-16 items-center justify-between md:h-20">
        <a
          href="#home"
          onClick={(e) => {
            e.preventDefault();
            window.scrollTo({ top: 0, behavior: "smooth" });
          }}
          className="flex cursor-pointer items-center gap-2.5"
          aria-label="漫阅指南首页"
        >
          <span className="flex h-9 w-9 items-center justify-center rounded-lg bg-primary-500 text-background-50">
            <i className="ri-book-2-line text-lg"></i>
          </span>
          <span className="font-heading text-2xl text-foreground-900">漫阅指南</span>
        </a>

        <nav className="hidden items-center gap-1 md:flex" aria-label="主导航">
          {navLinks.map((link) => (
            <button
              key={link.label}
              type="button"
              onClick={() => go(link.href)}
              className="cursor-pointer whitespace-nowrap rounded-md px-3.5 py-2 text-sm text-foreground-700 transition-colors hover:bg-background-100 hover:text-primary-700"
            >
              {link.label}
            </button>
          ))}
        </nav>

        <div className="flex items-center gap-3">
          <button
            type="button"
            onClick={() => go("#contact")}
            className="hidden cursor-pointer whitespace-nowrap rounded-full bg-primary-500 px-5 py-2.5 text-sm font-medium text-background-50 transition-colors hover:bg-primary-600 md:inline-flex"
          >
            订阅追更资讯
          </button>
          <button
            type="button"
            onClick={() => setOpen((v) => !v)}
            className="flex h-10 w-10 cursor-pointer items-center justify-center rounded-lg text-foreground-800 hover:bg-background-100 md:hidden"
            aria-label="切换菜单"
            aria-expanded={open}
          >
            <i className={`${open ? "ri-close-line" : "ri-menu-line"} text-xl`}></i>
          </button>
        </div>
      </div>

      {open && (
        <div className="border-t border-background-200/70 bg-background-50/95 backdrop-blur-md md:hidden">
          <nav className="section-x flex flex-col gap-1 py-4" aria-label="移动端导航">
            {navLinks.map((link) => (
              <button
                key={link.label}
                type="button"
                onClick={() => go(link.href)}
                className="cursor-pointer rounded-md px-3 py-2.5 text-left text-sm text-foreground-700 hover:bg-background-100 hover:text-primary-700"
              >
                {link.label}
              </button>
            ))}
            <button
              type="button"
              onClick={() => go("#contact")}
              className="mt-2 cursor-pointer rounded-full bg-primary-500 px-5 py-2.5 text-sm font-medium text-background-50"
            >
              订阅追更资讯
            </button>
          </nav>
        </div>
      )}
    </header>
  );
}